var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z","clipRule":"evenodd"}));
}

ArrowInline.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 20 20","fill":"currentColor","id":"arrow-right","version":"1.1"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
